<template>
  <main class="payout-history-wrapper">
    <h1>Withdrawals</h1>
    <h5>
      List of withdrawals from merchant account balance including transfers to
      other accounts and transfers to designated bank account.
    </h5>
    <form v-on:reset="handleReset">
      <fieldset>
        <label
          >Withdrawal reference
          <input type="text" v-model="searchForm.payoutReference"
        /></label>
      </fieldset>
      <fieldset>
        <label
          >Transfer date (from)<input
            type="date"
            v-model="searchForm.statusDateFrom"
            :class="{ invalid: !formValidation.areStatusDateValid }"
        /></label>
        <label
          >Transfer date (to)<input
            type="date"
            v-model="searchForm.statusDateTo"
            :class="{ invalid: !formValidation.areStatusDateValid }"
        /></label>
      </fieldset>
      <!-- Might be needed for future purposes -->
      <Transition name="fade">
        <fieldset v-if="shouldAdvancedSearchDisplay">
          <legend>Transaction type</legend>
          <label
            >Sending currency
            <input
              v-model="searchForm.sendingCurrency"
              list="sendingCurrencies"
            />
            <datalist id="sendingCurrencies">
              <option
                v-for="currency in availableCurrencies"
                :key="currency"
                :value="currency"
              >
                {{ currency }}
              </option>
            </datalist>
          </label>
          <label
            >Receiving currency
            <input
              v-model="searchForm.receivingCurrency"
              list="receivingCurrencies"
            />
            <datalist id="receivingCurrencies">
              <option
                v-for="currency in availableCurrencies"
                :key="currency"
                :value="currency"
              >
                {{ currency }}
              </option>
            </datalist>
          </label>
          <label
            >Payee Address<input
              type="text"
              class="wallet-address"
              v-model="searchForm.payeeWalletAddress"
          /></label>
        </fieldset>
      </Transition>
      <Transition>
        <fieldset v-if="shouldAdvancedSearchDisplay">
          <legend>Creation Date</legend>
          <label
            >From<input
              type="date"
              v-model="searchForm.creationDateFrom"
              :class="{ invalid: !formValidation.areCreationDateValid }"
          /></label>
          <label
            >To<input
              type="date"
              v-model="searchForm.creationDateTo"
              :class="{ invalid: !formValidation.areCreationDateValid }"
          /></label>
        </fieldset>
      </Transition>
      <ul class="button-grp">
        <button @click.prevent="findPayouts()">Search</button>
        <!-- <li>
          <button @click.prevent="toggleAdvancedSearch()">
            Advanced search
          </button>
        </li>
        <li><input type="reset" value="Reset form" /></li>
        <li>
          <button @click.prevent="downloadPayoutCSV()">Download as CSV</button>
        </li> -->
      </ul>
      <Transition name="fade">
        <ul
          class="errors-section"
          v-if="
            !formValidation.areCreationDateValid ||
              !formValidation.areStatusDateValid
          "
        >
          <li v-if="errorDownloadRefundsAsCsv">
            Error in downloading csv file, please try again.
          </li>
          <li v-if="!formValidation.areCreationDateValid">
            <strong>Creation</strong> dates are invalid :
            <strong>To Date</strong> should not be earlier than
            <strong>From Date</strong>
          </li>
          <li v-if="!formValidation.areStatusDateValid">
            <strong>Transfer dates</strong> are invalid :
            <strong>To Date</strong> should not be earlier than
            <strong>From Date</strong>
          </li>
        </ul>
      </Transition>
    </form>
    <div class="table-wrapper">
      <table aria-label="Payout table">
        <thead>
          <tr>
            <th>Withdrawal Reference</th>
            <th>Status</th>
            <th>Date</th>
            <!-- <th class="one-line">
              Total Fee
              <span class="tooltip">
                <img
                  src="../../assets/icons/help.svg"
                  alt="more info on fees"
                />
                <span class="tooltip-text">
                  <strong>GST inclusive if applicable</strong> (merchants
                  incorporated in Singapore)
                </span>
              </span>
            </th> -->
            <th>Preferred Currency</th>
            <th>Withdrawal Amount</th>
            <th>Type</th>
            <th>Bank Reference</th>
            <th>Action</th>
          </tr>
        </thead>
        <Transition name="fade">
          <tbody
            is="TransitionGroup"
            name="fade"
            v-if="payoutListGetter.length > 0"
          >
            <tr
              :key="payout.payout_reference"
              v-for="payout in payoutListGetter"
            >
              <!-- Withdrawal Reference -->
              <td>
                {{ payout.payout_reference }}
              </td>
              <!-- Withdrawal Status -->
              <td class="status">
                <span :class="payout.status">{{
                  formatStatus(payout.status)
                }}</span>
              </td>
              <!-- Withdrawal Date -->
              <td>
                {{
                  payout.status_date
                    ? `${formatToLocalDate(
                        payout.status_date
                      )}, ${formatToLocalTime(payout.status_date)}`
                    : '-'
                }}
              </td>
              <!-- Preferred Currency  -->
              <td>
                {{ payout.payout_currency }}
              </td>
              <!-- Withdrawal Amount -->
              <td>
                {{ formatFiatPrice(payout.withdraw_amount) }}
              </td>
              <!-- Type  -->
              <td>
                {{
                  payout.internal_transfer &&
                  payout.internal_transfer._creator_type
                    ? 'Internal transfer'
                    : 'Bank Transfer'
                }}
              </td>
              <!-- Bank Reference -->
              <td>
                {{
                  payout.internal_transfer &&
                  payout.internal_transfer._creator_type
                    ? '-'
                    : formatBankReference(payout.payout_date)
                }}
              </td>
              <!-- Action -->
              <td>
                <span v-if="!payout.internal_transfer">
                  <button
                    class="icon-btn"
                    @click.stop="
                      downloadWithdrawalPDFHandler(payout.payout_reference)
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-file vue-feather__content"
                    >
                      <path
                        d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
                      ></path>
                      <polyline points="13 2 13 9 20 9"></polyline>
                    </svg>
                    <span class="tooltip-text">
                      {{ 'Download PDF' }}
                    </span>
                  </button>
                </span>
              </td>
            </tr>
          </tbody>
        </Transition>
      </table>
      <Transition name="fade">
        <p
          class="emptyTable"
          v-if="
            !payoutListGetter ||
              (payoutListGetter && payoutListGetter.length <= 0)
          "
        >
          {{
            firstSearchMade
              ? 'No payouts matches this search, please try with other parameters'
              : "You don't have any payouts yet"
          }}
        </p>
      </Transition>
    </div>
    <ul class="button-grp" style="display: flex; justify-content: center">
      <li>
        <button :disabled="isPrevPayoutListExist" @click="prevPayoutList">
          Previous
        </button>
      </li>
      <li>
        <button :disabled="isNextPayoutListExist" @click="nextPayoutList">
          Next
        </button>
      </li>
    </ul>
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { InfoIcon, CheckIcon } from 'vue-feather-icons';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import fileDownload from 'js-file-download';
import { SUPPORTED_OVERALL_CURRENCIES } from '@/constants.js';
import { PAYOUT_STATUS } from '../../constants';

export default {
  components: {
    InfoIcon,
    CheckIcon,
    DatePicker,
  },
  data() {
    return {
      debugConsole: false,
      PAYOUT_STATUS: PAYOUT_STATUS,
      selectedMerchant: null,
      validateMerchantSelectionError: false,
      maxDate: new Date(Date.now()).toISOString().split('T')[0],
      errorDownloadPayoutAsCsv: false,
      cancelledPayoutReference: '',
      errorCancelPayout: false,
      shouldAdvancedSearchDisplay: false,
      firstSearchMade: false,
      selectedPayout: null,
      shouldDisplayDetailsModal: false,
      availableCurrencies: SUPPORTED_OVERALL_CURRENCIES,
      userRights: {
        canCancelCryptoPayout: false,
        canResendEmail: true,
        canChangeEmail: true,
      },
      searchForm: {
        payoutReference: '',
        status: '',
        statusDateFrom: '',
        statusDateTo: '',
        payeeWalletAddress: '',
        creationDateFrom: '',
        creationDateTo: '',
        accountType: 'all',
        balanceType: 'real',
        selectedAccount: '',
        sendingCurrency: '',
        receivingCurrency: '',
      },
      formValidation: {
        areStatusDateValid: true,
        areCreationDateValid: true,
        isWalletAddressSafe: true,
      },
    };
  },
  computed: {
    ...mapGetters([
      'activeAccountGetter',
      'cleanedTransactionsGetter',
      'payoutsGetter',
      'payoutListGetter',
      'selectedPayoutGetter',
      'activeMerchantKeyGetter',
      'merchantsGetter',
      'activeUserGetter',
      'payoutMetaDataGetter',
      'activeMerchantGetter',
      'currentActiveEntityAdminGetter',
      'approversGetter',
      'approvalGetter',
    ]),
    merchantList() {
      let merchants =
        this.merchantsGetter &&
        this.merchantsGetter.filter((item) => item.can_withdraw);
      return merchants;
    },
    isNextPayoutListExist() {
      if (this.payoutMetaDataGetter && this.payoutMetaDataGetter.next) {
        return false;
      } else {
        return true;
      }
    },
    isPrevPayoutListExist() {
      if (this.payoutMetaDataGetter && this.payoutMetaDataGetter.prev) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    payoutsGetter(newValue) {
      this.payouts = newValue;
    },
    cleanedTransactionsGetter() {
      this.initPage();
    },
    selectedPayoutGetter(newVal) {
      this.selectedPayout = newVal;
    },
    activeMerchantGetter() {
      this.initPage();
    },
  },
  mounted() {
    this.initPage();
  },
  beforeCreate() {
    this.$store.commit('UPDATE_PAYOUT_LIST', []);
  },
  beforeDestroy() {
    this.$store.commit('UPDATE_PAYOUT_LIST', []);
  },
  methods: {
    ...mapActions([
      'fetchPayoutsAction',
      'fetchMerchantWithdrawList',
      'downloadPayoutAsCSV',
      'fetchNextPayoutListAction',
      'fetchPrevPayoutListAction',
      'apiGetApprovers',
      'apiGetApproval',
      'downloadWithdrawalPDF',
    ]),
    initPage() {
      // TODO refactor the current pageInit function
      this.account = this.activeAccountGetter;
      if (!this.account || !this.account.apiId) {
        console.error('No active wallet found.');
        return;
      }
      const merchantKey = this.activeMerchantKeyGetter;
      this.selectedMerchant = merchantKey;

      this.getRights();
      this.initForm();

      this.apiGetApprovers(this.activeMerchantGetter.id).then(() => {
        console.debug('Get payout approvers');
      });

      this.apiGetApproval(this.activeMerchantGetter.id).then(() => {
        console.debug('Get Payout approval');
      });
    },

    // user actions
    findPayouts() {
      if (!this.isFormValid()) {
        return;
      }
      this.firstSearchMade = true;
      const payload = this.buildPayload();
      if (!payload) {
        console.error('could not build valid payload');
        return;
      }
      this.$store.dispatch('fetchMerchantWithdrawList', payload);
    },
    downloadPayoutCSV() {
      if (!this.isFormValid()) {
        return;
      }
      const payload = this.buildPayload();
      payload.type = 'withdraw';

      this.downloadPayoutAsCSV(payload)
        .then((res) => {
          if (this.debugConsole)
            console.log('Result of download payout as csv', res);
          fileDownload(res.data, 'payouts.csv');
          this.errorDownloadPayoutAsCsv = false;
        })
        .catch((err) => {
          if (this.debugConsole)
            console.log('Error in download payout as csv', err);
          this.errorDownloadPayoutAsCsv = true;
        });
    },
    async nextPayoutList() {
      if (this.payoutMetaDataGetter.next) {
        try {
          const payload = {};
          payload.merchant_key = this.selectedMerchant;
          let result = await this.fetchNextPayoutListAction(payload);
          if (this.debugConsole)
            console.log('Fetch Next PayoutList successful', result);
        } catch (err) {
          console.error('Fetch Next PayoutList error', err);
        }
      }
    },
    async prevPayoutList() {
      if (this.payoutMetaDataGetter.prev) {
        try {
          const payload = {};
          payload.merchant_key = this.selectedMerchant;
          let result = await this.fetchPrevPayoutListAction(payload);
          if (this.debugConsole)
            console.log('Fetch Prev PayoutList successful', result);
        } catch (err) {
          console.error('Fetch Prev PayoutList error', err);
        }
      }
    },

    // getters
    getRights() {
      const currentActiveMerchantId =
        this.activeMerchantGetter && this.activeMerchantGetter.id;
      //determine to show if the user has permission to cancel a payout or not
      this.userRights.canCancelCryptoPayout = this.isAllowed(
        this.currentActiveEntityAdminGetter,
        currentActiveMerchantId,
        'payout_links',
        'D'
      );
      this.userRights.canResendEmail = this.isAllowed(
        this.currentActiveEntityAdminGetter,
        currentActiveMerchantId,
        'payout_links',
        'R'
      );
      this.userRights.canChangeEmail = this.isAllowed(
        this.currentActiveEntityAdminGetter,
        currentActiveMerchantId,
        'payout_links',
        'W'
      );
    },

    // validation and checks
    isFormValid() {
      let isDataValid = true;

      // Creation dates
      if (
        !this.areDatesValid(
          this.searchForm.creationDateFrom,
          this.searchForm.creationDateTo
        )
      ) {
        isDataValid = false;
        this.formValidation.areCreationDateValid = false;
      } else {
        this.formValidation.areCreationDateValid = true;
      }
      // Modified dates
      if (
        !this.areDatesValid(
          this.searchForm.statusDateFrom,
          this.searchForm.statusDateTo
        )
      ) {
        isDataValid = false;
        this.formValidation.areStatusDateValid = false;
      } else {
        this.formValidation.areStatusDateValid = true;
      }
      // wallet

      return isDataValid;
    },
    areDatesValid(fromD, toD) {
      if (!fromD || !toD) return true; // only one set
      if (
        fromD &&
        toD &&
        new Date(fromD) < new Date(toD) &&
        new Date(fromD) !== new Date(toD)
      ) {
        this.invalidDates = false;
        return true;
      } else {
        this.invalidDates = true;
        return false;
      }
    },

    initForm(event) {
      if (event) event.preventDefault();
      this.searchForm = {
        payoutReference: '',
        status: 'done',
        statusDateFrom: '',
        statusdateTo: '',
        payeeWalletAddress: '',
        creationDateFrom: '',
        creationDateTo: '',
        accountType: 'all',
        balanceType: 'real',
      };
      this.findPayouts();
    },
    handleReset(event) {
      if (event) event.preventDefault();
      this.searchForm = {
        payoutReference: '',
        status: 'done',
        statusDateFrom: '',
        statusdateTo: '',
        payeeWalletAddress: '',
        creationDateFrom: '',
        creationDateTo: '',
        accountType: 'all',
        balanceType: 'real',
      };
      this.findPayouts();
    },
    toggleAdvancedSearch() {
      this.shouldAdvancedSearchDisplay = true;
    },

    // formatting functions
    buildPayload() {
      const payload = {};
      payload.merchant_key =
        this.activeMerchantGetter && this.activeMerchantGetter.merchant_key;

      if (this.searchForm.payoutReference) {
        payload.payout_reference = this.searchForm.payoutReference;
      }

      if (this.searchForm.status) {
        payload.status = this.searchForm.status;
      }

      if (this.searchForm.statusDateFrom) {
        payload.from_modified_date = this.formatDate(
          this.searchForm.statusDateFrom
        );
      }
      if (this.searchForm.statusDateTo) {
        payload.to_modified_date = this.getNextDay(
          this.searchForm.statusDateTo
        );
      }

      if (this.searchForm.creationDateFrom) {
        payload.from_date = this.formatDate(this.searchForm.creationDateFrom);
      }

      if (this.searchForm.creationDateTo) {
        payload.to_date = this.getNextDay(this.searchForm.creationDateTo);
      }

      if (this.searchForm.balanceType) {
        payload.bal_type = this.searchForm.balanceType;
      }

      if (this.searchForm.payeeWalletAddress) {
        payload.wallet_address = this.searchForm.payeeWalletAddress;
      }

      if (this.searchForm.accountType) {
        payload.account_type = 'local-local';
      }

      if (this.searchForm.receivingCurrency) {
        payload.receiving_currency = this.searchForm.receivingCurrency;
      }

      if (this.searchForm.sendingCurrency) {
        payload.sending_currency = this.searchForm.sendingCurrency;
      }

      return payload;
    },

    formatStatus(status) {
      switch (status) {
        case PAYOUT_STATUS.PENDING_BROADCAST:
          return 'Pending broadcast';
        case PAYOUT_STATUS.PENDING_CONFIRMATION:
          return 'Pending confirmation';
        case PAYOUT_STATUS.PENDING_APPROVAL:
          return 'Pending approval';
        case PAYOUT_STATUS.PENDING_AUTHORIZATION:
          return 'Pending authorization';
        default:
          return status;
      }
    },

    downloadWithdrawalPDFHandler(payoutReference) {
      const payload = {};
      payload.merchantKey = this.activeMerchantGetter.merchant_key;
      payload.payoutReference = payoutReference;

      this.downloadWithdrawalPDF(payload)
        .then((res) => {
          const blobData = new Blob([res.data], { type: 'application/pdf' });
          const fileUrl = window.URL.createObjectURL(blobData);

          const downloadLink = document.createElement('a');
          downloadLink.href = fileUrl;
          downloadLink.download = `${payoutReference}`;
          downloadLink.click();
          window.URL.revokeObjectURL(fileUrl);
        })
        .catch((err) => {
          console.error('error in downloading PDF', err);
          this.$vs.notify({
            title: 'Error',
            text: 'Failed to download PDF. Please try again in a few mins',
            color: 'danger',
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
main.payout-history-wrapper {
  position: relative;
  & > h1 {
    text-transform: uppercase;
    font-size: 32px;
    font-weight: bold;
    color: #505050;
    margin-bottom: 24px;
  }

  h5 {
    margin-bottom: 20px;
  }

  form {
    margin-bottom: 32px;
    display: flex;
    flex-wrap: wrap;

    fieldset {
      border: none;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 12px;
      margin-right: 32px;
      align-items: flex-end;

      label {
        font-size: 12px;
        padding-right: 6px;
        min-width: 100px;
        &:last-of-type {
          padding-right: 0;
        }
      }

      input,
      select {
        display: block;
        width: 100%;
        height: 38px;
        border-radius: 5px;
        padding: 3px;
        border: 0.5px solid lightgrey;
        &[type='date'] {
          min-width: 150px;
        }
        &[type='email'] {
          min-width: 300px;
        }
        &.currency {
          text-transform: uppercase;
        }
        &.wallet-address {
          min-width: 300px;
        }
        &.invalid {
          border-color: red;
        }
      }

      select {
        text-transform: capitalize;
      }

      &.dates {
        display: flex;
        align-items: flex-end;

        button {
          background-color: rgb(7, 85, 147);
          color: white;
          padding: 12px;
          margin-left: 8px;
          margin-top: 8px;
          border-radius: 6px;
          border: none;
          text-align: center;
          font-family: 'Montserrat', Helvetica, Arial, sans-serif;
          font-size: 1rem;
          max-height: 38px;

          &:hover {
            cursor: pointer;
            background-color: rgb(5, 59, 102);
          }
        }
      }

      &.references {
        p {
          label {
            span {
              font-weight: bold;
            }
          }
        }
      }
    }
    ul.errors-section {
      color: red;
      font-size: 12px;
      display: block;
      width: 100%;
    }
    ul.button-grp {
      li:last-child {
        margin-right: 0;
        margin-left: 24px;
      }
    }
  }
  div.table-wrapper {
    overflow-x: auto;
    padding: 0;
    margin: 0;
    box-shadow: 0 0 5px 0 #b5b5b5;
    border-radius: 8px;
    max-height: 90vh;
    background: white;

    table {
      position: relative;
      z-index: 0;
      background: white;
      border-radius: 6px;
      margin: 0;
      border-collapse: collapse;
      border-spacing: 0;
      width: 100%;
      border: 1px solid #ddd;

      * {
        text-align: center;
      }

      thead {
        tr {
          position: sticky;
          top: -1px;
          background: white;
          z-index: 1;
          // box-shadow: inset 0px -1px 0px 0px #b5b5b5;
          th {
            font-size: 14px;
            padding: 12px;
            box-shadow: inset 0px -1px 0px 0px #b5b5b5;
            &:first-of-type {
              position: sticky;
              left: -1px;
              top: -1px;
              background: white;
              box-shadow: inset -0.5px -1px 0px 0px #b5b5b5;
            }
            &.one-line {
              white-space: nowrap;
            }
            .tooltip {
              position: relative;
              img {
                height: 16px;
                width: 16px;
                position: relative;
                top: 3px;
              }
              .tooltip-text {
                visibility: hidden;
                position: absolute;
                background: #efefef;
                padding: 6px 4px;
                border-radius: 3px;
                font-size: 12px;
                max-width: 550px;
                min-width: 150px;
                white-space: normal;
                font-weight: normal;
                top: -16px;
              }

              &:hover {
                .tooltip-text {
                  visibility: visible;
                }
              }
            }
          }
        }
      }

      tbody {
        z-index: 0;
        tr {
          padding: 4px 6px;
          border-bottom: solid 1px #b5b5b5;
          transition: ease-in-out 0.2s;
          &:hover {
            background-color: #e1e1e1;
          }

          td {
            min-width: 100px;
            padding: 12px;
            white-space: nowrap;
            button {
              position: relative;
              background-color: rgb(7, 85, 147);
              color: white;
              border-radius: 6px;
              border: none;
              text-align: center;
              font-family: 'Montserrat', Helvetica, Arial, sans-serif;
              font-size: 1rem;
              padding: 6px;
              margin-right: 6px;
              & > .tooltip-text {
                visibility: hidden;
                position: absolute;
                background-color: #505050;
                border-radius: 6px;
                padding: 3px;
                z-index: 1;
                left: -150px;
                bottom: 0px;
              }
              &:hover {
                cursor: pointer;
                background-color: rgb(5, 59, 102);
                & > .tooltip-text {
                  visibility: visible;
                }
              }
              &.cancel {
                color: white;
                background-color: #ca2828;
                &:hover {
                  background-color: #8c2222;
                }
              }

              &.approve {
                color: white;
                background-color: #26aa6d;
                &:hover {
                  background-color: #1f8e3e;
                }
              }

              &.icon-btn {
                svg {
                  float: left;
                }
              }

              &.link-style {
                border: none;
                background-color: transparent;
                color: #505050;
                &:hover {
                  color: rgb(7, 85, 147);
                  text-decoration: underline;
                }
              }

              &:last-child {
                margin-right: 0;
              }
            }

            &:first-of-type {
              position: sticky;
              left: -1px;
              background: white;
              box-shadow: inset -0.5px 0px 0px 0px #b5b5b5;
            }
          }
        }
      }
      .dates {
        white-space: nowrap;
      }
      .actions {
        display: flex;
        justify-content: center;
      }
    }

    p.emptyTable {
      width: 100%;
      margin: 12px;
    }
  }

  .status span {
    text-transform: capitalize;
    padding: 3px 6px;
    border-radius: 6px;
    border: 1px solid transparent;
    &.new {
      color: white;
      background-color: rgb(72, 72, 203);
    }
    &.confirm,
    &.done {
      background-color: green;
      color: white;
    }
    &.cancel {
      background-color: white;
      border-color: #8c2222;
      color: #8c2222;
    }
    &.invalid {
      background-color: #8c2222;
      color: white;
    }
    &.pending_approval,
    &.pending_broadcast,
    &.pending_confirmation,
    &.pending_authorization {
      background-color: moccasin;
    }
  }

  article {
    margin-top: 24px;
    dl {
      margin-top: 12px;
      div {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin-bottom: 12px;
        dt {
          margin-right: 6px;
        }
      }
    }
  }
}
.button-grp {
  display: flex;
  flex-wrap: wrap;
  margin-top: 24px;
  margin-bottom: 12px;
  width: 100%;
  li {
    margin-right: 8px;
  }
  input,
  button {
    background-color: rgb(7, 85, 147);
    color: white;
    padding: 12px 20px;
    border-radius: 6px;
    border: none;
    text-align: center;
    font-family: 'Montserrat', Helvetica, Arial, sans-serif;
    font-size: 1rem;
    margin-right: 5px;

    &.outline {
      border-color: rgb(7, 85, 147);
      color: rgb(7, 85, 147);
      background-color: white;
      border: 1px solid;
    }

    &:hover {
      cursor: pointer;
      background-color: rgb(5, 59, 102);
      color: white;
    }

    &:disabled {
      background-color: #ddd;
      cursor: not-allowed;
    }
  }
}

.email-popup {
  div {
    border: none;
    input,
    select {
      display: block;
      width: 100%;
      height: 38px;
      border-radius: 5px;
      padding: 3px;
      border: 0.5px solid lightgrey;
      &[type='email'] {
        min-width: 300px;
      }
      &.invalid {
        border-color: red;
      }
    }

    &.icon {
      p {
        position: relative;
        margin-left: 24px;
        &::before {
          content: '';
          background-image: url('../../assets/icons/checkedTask_green.svg');
          background-size: cover;
          display: inline-block;
          position: absolute;
          height: 24px;
          width: 24px;
          top: calc(50% - 12px);
          left: -30px;
        }
      }
      &.error {
        p::before {
          background-image: url('../../assets/icons/errorIcon_red.svg');
        }
      }
    }
  }
  .button-grp {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    button {
      margin-right: 12px;
      &:last-of-type {
        margin-right: 0;
      }
    }
  }
}
</style>
